import React, {useEffect, useState, Fragment} from 'react';
import RecipeItem from '../../components/ui/RecipeItem';
import Pagination from '../../components/ui/Pagination'
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import Loader from '../../components/ui/Loader';
import LoadModules from '../../components/ui/LoadModules'
import {getRecipes, getStaticPage} from '../../utils/services';
import Meta from '../../components/ui/Meta';
import DataFilter from '../../components/ui/DataFilter';
import {currentLang, accentsTidy, recipeURL} from '../../utils/functions';
import {isNil, isNull} from 'lodash';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SearchState from '../../components/ui/SearchState';

const RecipeList = ({loading, recipes_data, recipes_list_static, page, filter}) => {
	const [data, setData] = useState();
	const [staticData, setStaticData] = useState();
	const [modules, setModules] = useState(null);
	const [filteredData, setFilteredData] = useState([]);
	const [filterType, setFilterType] = useState(null);
	const [searchStatus, setSearchStatus] = useState(null);
	const { t } = useTranslation();
	const history = useHistory();

	useEffect(() => {
		if (isNil(recipes_data) && isNil(recipes_list_static)) {
			getRecipes();
			getStaticPage(t("menu.recipes"), 'recipes_list_static');
		}
		if(recipes_data && recipes_data.data !== undefined){
			recipes_data.data.per_page = 9;
			recipes_data.data.total = recipes_data.total;
			setData(recipes_data.data);
		}
		if(data){
			filterFunc({"value":filter, "pageNumber":page});
		}

	}, [recipes_data, history.location.pathname]);

	useEffect(() => {
		
		if(recipes_list_static !== undefined){
			setStaticData(recipes_list_static);		
			if(recipes_list_static.modules && recipes_list_static.modules.module !== null){
				setModules(recipes_list_static.modules);
			}
		}
	}, [recipes_list_static]);
	
	const filterFunc = ({pageNumber, value, search, searchState}) =>{
		if(searchState == "search_empty"){
			setSearchStatus('only3char');
			setFilteredData([]);
			return false;
		}
		//console.log(search);
		if(search && search.length > 0){
			search = search.toLowerCase();
			var fdata = [];
			if(search.length < 2){
				setSearchStatus('3char');
				setFilteredData(fdata);
			}else{
				data.map((item, index)=>{
					if(accentsTidy(item.title).includes(search)){
						fdata.push(item);
					}
				});
				if(fdata.length < 1){
					setSearchStatus('noresult');
					//console.log(fdata);
					setFilteredData(fdata);
				}else{
					fdata.total = 100;
					fdata.per_page = 1000;
					setFilteredData(fdata);
					setSearchStatus(null);
				}
				
			}
		}else{
			setSearchStatus(null);
			if(!pageNumber) pageNumber = 1;
			var fdata = [];
			var j = 0;
			var i = (pageNumber-1)*data.per_page;

			var total = 0;
			var id = 0;
			
			if(value != filterType){
				page = 1;
			}

			setFilterType(value);
			data.map((item, index)=>{
				
				if(isNull(value)){
					if(j < data.per_page && id >= i){
						fdata.push(item);
						j++;
					}
					id++;
				}else{

					if(item.meatcut_animals && item.meatcut_animals.includes(value)){
						total++;
						if(j < data.per_page && id >= i){
							fdata.push(item);
							j++;
						}
						id++;
					}
				}
			})
			
			if(isNull(value)){
				fdata.total = data.total;
			}else{
				fdata.total = total;
			}
			fdata.per_page = data.per_page;
			setFilteredData(fdata);
		}
	}

	useEffect(() => {
		if(!isNil(data)){
			filterFunc({"pageNumber": page, "value": filter});
		}
	}, [data])


	if (loading) {
		return <Loader />
	} else {
			
		return (
			<Fragment>
			<LoadModules modules={modules} type="top" />
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="back__row mt-30 mb-30">
							<a href={"/"+currentLang()+"/"}> <span className="icon-back"></span> </a>
						</div>
					</div>
				</div>
				{staticData && 
					<div className="row">
						<Meta
							title={staticData.seo_title ? staticData.seo_title : staticData.title}
							description={staticData.seo_description ? staticData.seo_description : staticData.body}
						/>
						{staticData.body &&
							<div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2 mb-20">
								<h1 className="heading--h1">{staticData.title}</h1>
								<p>
									{parse(staticData.body)}
								</p>
							</div>
						}
					</div>
				}
				<DataFilter type="recipes" filterType={filterType} filterFunc={filterFunc} data={data} />
				<div className="row">
					{filteredData && filteredData.map((item, index)=>{
						return (
							<div key={index} className="col-xs-12 col-md-6 col-lg-4">
								<RecipeItem detail={item} />
							</div>
						)
					})}
				</div>
				<SearchState status={searchStatus} />
				{data && filteredData && 
					<Pagination url={recipeURL('')} data={filteredData} curPage={page} loadData={filterFunc} type="client" filterType={filterType} />
				}

			</div>
			<LoadModules modules={modules} type="bottom" />
			</Fragment>
		)
	}
}

export default flatstore.connect(['loading', 'recipes_data', 'recipes_list_static'])(RecipeList);
